import { render } from "./SelectOptionsCompany.vue?vue&type=template&id=42ea0170"
import script from "./SelectOptionsCompany.vue?vue&type=script&lang=js"
export * from "./SelectOptionsCompany.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__